// extracted by mini-css-extract-plugin
module.exports = {"container":"SetupSecurity_container__3piEy","row":"SetupSecurity_row__1zu-8"};